
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";

interface User {
  id: number;
  name: string;
  email: string;
  role_id: number;
  mobile_number?: string;
}

export default function Sidebar() {
  const location = useLocation();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("gp_user");
      if (storedUser) {
        const parsedUser: User = JSON.parse(storedUser);
        setUser(parsedUser);
      }
    } catch (error) {
      console.error("Error parsing user:", error);
    }
  }, []);

  const roleId = Number(user?.role_id);
  const isAdmin = [1, 2, 3, 7, 8].includes(roleId);
  const isGlobalPartner = roleId === 28;

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">

        {isGlobalPartner && (
          <>
            <Link
              to="/dashboard"
              className={`sidebar-link ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              Dashboard
            </Link>

            <Link
              to="/leads"
              className={`sidebar-link ${
                location.pathname === "/leads" ? "active" : ""
              }`}
            >
              Leads
            </Link>
          </>
        )}

        {isAdmin && (
          <Link
            to="/admin"
            className={`sidebar-link ${
              location.pathname === "/admin" ? "active" : ""
            }`}
          >
            City-Wise Leads Report
          </Link>
        )}
               {/* {isAdmin && (
          <Link
            to="/admin-leads"
            className={`sidebar-link ${
              location.pathname === "/admin-leads" ? "active" : ""
            }`}
          >
            City-Wise Leads
          </Link>9
        )} */}

      </nav>
    </div>
  );
}